/*
* @Author: gujianghua
* @Date:   2020-08-21 10:27:54
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-08-25 18:19:40
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	//列表
	getDataList(params) {
		return service({
			url: '/cloud/uac/v1/doc/distribution/findByPage',
			method: 'get',
			params: params
		})
	},
	//列表
	add(data) {
		return service({
			url: '/cloud/uac/v1/doc/distribution/insert',
			method: 'post',
			data: data
		})
	},
	//更新
	update(data) {
		return service({
			url: '/cloud/uac/v1/doc/distribution/update',
			method: 'post',
			data: data
		})
	},
	// 删除
	deleteData(path) {
		return service({
			url: '/cloud/uac/v1/doc/distribution/delete/' + path,
			method: 'get'
		})
	},
	getDetail(id) {
		return service({
			url: '/cloud/uac/v1/doc/distribution/findBy/' + id,
			method: 'get'
		})
	},
	// 导出
	exportExcel: function exportExcel(data) {
	    let url = v2 + '/cloud/uac/v1/doc/distribution/downloadExcel?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
}


// WEBPACK FOOTER //
// ./src/api/thirdManage/distributemanage.js